import { useState, useEffect } from 'react';

const useCollaboration = (apiClient, nodes, connectors) => {
  const [collaborators, setCollaborators] = useState([]);
  
  useEffect(() => {
    if (!apiClient) {
      // Simulación para desarrollo
      const mockCollaborators = [
        { id: 'user1', name: 'Usuario 1', position: { x: 100, y: 100 }, color: '#ff0000' },
        { id: 'user2', name: 'Usuario 2', position: { x: 200, y: 200 }, color: '#00ff00' }
      ];
      setCollaborators(mockCollaborators);
      return;
    }
    
    const handleUpdate = (data) => {
      setCollaborators(data.collaborators);
    };
    
    apiClient.subscribe('diagram-update', handleUpdate);
    return () => apiClient.unsubscribe('diagram-update', handleUpdate);
  }, [apiClient]);
  
  return { collaborators };
};

export default useCollaboration;